const FETCH_USER = {
    REQUEST: 'FETCH_USER_REQUEST',
    SUCCESS: 'FETCH_USER_SUCCESS',
    FAILURE: 'FETCH_USER_FAILURE',
};

export function fetchUser() {
    return {
        types: [FETCH_USER.REQUEST, FETCH_USER.SUCCESS, FETCH_USER.FAILURE],
        payload: {
            request: {
                url: '/user',
            },
        },
    };
}

export function reducer(state, action) {
    switch (action.type) {
        case FETCH_USER.REQUEST:
            return {
                ...state,
                user: { ...state.user, isFetching: true }
            };
        case FETCH_USER.SUCCESS:
            return {
                ...state,
                user: { ...action.payload.data.user, isFetching: false },
            };
        case FETCH_USER.FAILURE:
            return {
                ...state,
                user: { ...state.user, isFetching: false }
            };
        default: {
            return state;
        }
    }
}
